module.exports = __webpack_public_path__ + "static/img/orange2_tr.15e67c6e.png";